export default __webpack_public_path__ + "static/media/personality.791c34d1.svg";